import { useCreditCardPayment } from "./hooks/useCreditCardPayment";
import { IBreachDetails } from "../../models/breach-details.interface";
import { Button, Typography } from "@mui/material";
import { useMemo } from "react";

interface IProps {
  details: IBreachDetails;
  email: string;
}
export const CreditCardButton = ({ details, email }: IProps) => {
  const {
    payTicketWithCreditCard,
    creditCardPaymentError,
    creditCardPaymentLoading,
  } = useCreditCardPayment(details, email);

  const amount = useMemo(() => details.amount, [details.amount]);

  const shouldBePaidDisabled = useMemo(() => {
    return creditCardPaymentLoading || !amount;
  }, [creditCardPaymentLoading, amount]);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={payTicketWithCreditCard}
        disabled={shouldBePaidDisabled}
        sx={{ width: "100%" }}
      >
        {creditCardPaymentLoading ? "Loading..." : "Pay with Credit/Debit Card"}
      </Button>
      {creditCardPaymentError && (
        <Typography variant="body1" color="error">
          {creditCardPaymentError}
        </Typography>
      )}
    </>
  );
};
